











































import Vue from 'vue';
import MStoreDeleteConfirmation from '@/components/shared/MStoreDeleteConfirmation.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { CabinetConfigurationHelper, ModalHelpers } from '@/mixins';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import {
  CabinetConfigurationModel,
  CabinetReferenceType,
  DeleteConfigurationModel,
  DeleteResponseType,
  DocumentTypeConfigurationModel,
  StoreConstants
} from '@/types';
import { mapActions, mapGetters } from 'vuex';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper, ModalHelpers],
  data() {
    return {
      cabinetConfiguration: {} as CabinetConfigurationModel,
      documentTypeConfiguration: {} as DocumentTypeConfigurationModel,
      isLoading: true,
      isSubmitting: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
    ]),
    cardHeader(this: any) {
      return `Delete ${this.documentTypeConfiguration.description} Document Type`;
    },

    documentReferencesCount(this: any) {
      return (
        (this.cabinetConfiguration as CabinetConfigurationModel).cabinetReferences?.filter(
          (x) =>
            x.referenceType === CabinetReferenceType.Document &&
            x.documentTypeId != null &&
            x.documentTypeId === this.documentTypeConfiguration.id
        ).length ?? 0
      );
    }
  },
  methods: {
    ...mapActions(StoreConstants.Configuration.ModuleName, [
      StoreConstants.Configuration.Actions.GetConfigurationTree,
      StoreConstants.Configuration.Actions.SetSelectedNodeToExpandOnMount
    ]),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage
    ]),
    async getCabinetConfigurationSettingsAsync(this: any) {
      await this.getCabinetConfigurationSettingsWithErrorPage();
    },
    async getCabinetConfigurationAsync(this: any) {
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(
          this.$route.params.cabinetId
        );
        this.documentTypeConfiguration = this.cabinetConfiguration.documentTypes.find(
          (docType: DocumentTypeConfigurationModel) => docType.id === Number(this.$route.params.documentTypeId)
        );
        this.cabinetConfiguration.configurationChangeId = this[
          StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
        ];
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onDeleteConfirmation(this: any) {
      this.isSubmitting = true;
      try {
        await this.deleteDocumentType(false);
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async deleteDocumentType(this: any, ignoreWarnings: boolean) {
      const response = await CabinetConfigurationService.deleteDocumentTypeAsync({
        id: this.documentTypeId,
        configurationChangeId: this.cabinetConfigurationChangeId,
        continue: ignoreWarnings
      } as DeleteConfigurationModel);

      if (response.deleteResponseType === DeleteResponseType.Deleted) {
        await this[StoreConstants.Configuration.Actions.GetConfigurationTree]();
        SnotifyConfiguration.showSuccess(
          `Document Type ${this.documentTypeConfiguration.description} successfully deleted`
        );
        this[StoreConstants.Configuration.Actions.SetSelectedNodeToExpandOnMount]();
        this.navigateToCabinetDashboard(this.cabinetId);
        return;
      }

      const userContinue = await this.showNotificationModalAsync(response.notification);
      if (userContinue) {
        await this.deleteDocumentType(true);
      }
    },
    async onCancelDeleteConfirmation(this: any) {
      this.navigateToDocumentTypeDashboard(this.cabinetId, this.documentTypeId);
    },
    checkValidLock(this: any) {
      if (this.validLock) {
        return;
      }
      SnotifyConfiguration.showInformation('Sorry, you must be in edit mode to make changes.');
      this.navigateToCabinetDashboard(this.cabinetId);
    }
  },
  async mounted(this: any) {
    await this.getLock();
    await this.getCabinetConfigurationAsync();
    this.checkValidLock();
  },
  created(this: any) {
    // tslint:disable-next-line:max-line-length
    this.$route.meta.treePath = `/configuration/cabinet/${this.$route.params.cabinetId}/documenttype/${this.$route.params.documentTypeId}/dashboard`;
    this.cabinetId = this.$route.params.cabinetId;
    this.documentTypeId = this.$route.params.documentTypeId;
  },
  beforeDestroy(this: any) {
    this.$route.meta.treePath = null;
  },
  components: {
    MStoreDeleteConfirmation,
    LoadingSpinner
  }
});
